import React, { useContext } from 'react';

import { HeaderStyledNav, HeaderStyledNavWrapper } from './AudiHeaderNavStyles';
import AudiHeaderActiveBar from '../AudiHeaderActiveBar/AudiHeaderActiveBar';
import AudiHeaderNavItem from '../AudiHeaderNavItem/AudiHeaderNavItem';
import type { AudiHeaderNavProps } from '../../interfaces/header-components.interfaces';
import AudiHeaderDealerContext from '../AudiHeaderDealerContext/AudiHeaderDealerContext';
import { DealerContext } from '../../context';
import DealerSearchMobile from '../AudiHeaderDealerContext/DealerSearchMobile';
import { ServiceContext } from '../../context/ServiceContext';

const AudiHeaderNav: React.FC<AudiHeaderNavProps> = ({
  headerNavigationItemsAmount,
  navigation,
  headerDispatch,
  headerState,
  navigationElement,
  isClosing,
  isOpen,
  useFootnoteReferenceServiceTextParserHook,
  useOneLayer,
  windowWidth,
  onClickDealerContext,
  onClickDealerSearchContext,
  showDealerAdditionalData,
  dealerSearch,
  dealerSearchGeolocationEnabled,
  isTierOneDomain,
}) => {
  const { dealerData, renderDealerContext } = useContext(DealerContext);
  const { headerStateService } = useContext(ServiceContext);
  const isSubNavOpen = headerState.activeItem.index !== -1;

  let isSmallView = true;
  headerStateService.registerCallback((headerStateRemote) => {
    isSmallView = headerStateRemote.isMobileView;
  });

  return (
    <HeaderStyledNavWrapper
      headerNavigationItemsAmount={headerNavigationItemsAmount}
      isOpen={isOpen}
      isSubNavOpen={isSubNavOpen}
      ref={navigationElement}
      showSearch={headerState.activeItem.showSearch}
      showDealerSearch={headerState.activeItem.showDealerSearch}
    >
      <HeaderStyledNav
        aria-label="Main"
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        isOpen={isOpen}
        isSubNavOpen={isSubNavOpen}
        showDealerSearch={headerState.activeItem.showDealerSearch}
        role="navigation"
      >
        {navigation?.map((navigationItem, index) => {
          const link = navigationItem?.Link;
          const key = link ? `${link?.Text}${link?.Url}` : `link-${index}`;

          return (
            <AudiHeaderNavItem
              headerDispatch={headerDispatch}
              headerNavigationItemsAmount={headerNavigationItemsAmount}
              headerState={headerState}
              index={index}
              isClosing={isClosing}
              isSubNavOpen={isSubNavOpen}
              item={navigationItem}
              key={key}
              useFootnoteReferenceServiceTextParserHook={useFootnoteReferenceServiceTextParserHook}
              useOneLayer={useOneLayer}
            />
          );
        })}
      </HeaderStyledNav>
      {/* Dealer Context Mobile View */}
      {!!dealerData && renderDealerContext && isSmallView && (
        <AudiHeaderDealerContext
          isMobileView
          headerNavigationItemsAmount={headerNavigationItemsAmount}
          onClickDealerContext={onClickDealerContext}
          onClickDealerSearchContext={() => {}}
          showDealerAdditionalData={showDealerAdditionalData}
        />
      )}
      {/* Dealer Search Mobile View */}
      {isSmallView && !dealerData && renderDealerContext && dealerSearch && isTierOneDomain && (
        <DealerSearchMobile
          isMobileView
          headerState={headerState}
          headerNavigationItemsAmount={headerNavigationItemsAmount}
          onClickDealerSearchContext={onClickDealerSearchContext}
          showDealerSearch={headerState.activeItem.showDealerSearch}
          dealerSearchGeolocationEnabled={dealerSearchGeolocationEnabled}
        />
      )}
      <AudiHeaderActiveBar
        headerNavigationItemsAmount={headerNavigationItemsAmount}
        headerState={headerState}
        windowWidth={windowWidth}
      />
    </HeaderStyledNavWrapper>
  );
};

export default AudiHeaderNav;
